export default __webpack_public_path__ + "static/media/App-audio-playback-image.15c9af73.png";